// This file is AUTOGENERATED, do not edit it manually!!!

import { taskDetails as taskDetailsde } from './taskDetailsResx.de';
import { taskDetails as taskDetailsen } from './taskDetailsResx.en';
import { taskDetails as taskDetailsen_risk } from './taskDetailsResx.en_risk';
import { taskDetails as taskDetailses } from './taskDetailsResx.es';
import { taskDetails as taskDetailsfr } from './taskDetailsResx.fr';
import { taskDetails as taskDetailsit } from './taskDetailsResx.it';
import { taskDetails as taskDetailsnl } from './taskDetailsResx.nl';
import { taskDetails as taskDetailspl } from './taskDetailsResx.pl';
import { taskDetails as taskDetailspt } from './taskDetailsResx.pt';
import { taskDetails as taskDetailsru } from './taskDetailsResx.ru';
import { taskDetails as taskDetailssk } from './taskDetailsResx.sk';
import { taskDetails as taskDetailssv } from './taskDetailsResx.sv';
import { taskDetails as taskDetailstr } from './taskDetailsResx.tr';

const langMap: { [k: string]: Partial<typeof taskDetailsen> } = {
    de: taskDetailsde,
    en: taskDetailsen,
    en_risk: taskDetailsen_risk,
    es: taskDetailses,
    fr: taskDetailsfr,
    it: taskDetailsit,
    nl: taskDetailsnl,
    pl: taskDetailspl,
    pt: taskDetailspt,
    ru: taskDetailsru,
    sk: taskDetailssk,
    sv: taskDetailssv,
    tr: taskDetailstr,
};

/* tslint:disable: max-line-length */
export const taskDetailsResx = {
    /**
    * en: Actual Compl. Date: 
    */
    get actualCompletionDate() {
        return langMap[ep.resxCulture].actualCompletionDate || langMap.en.actualCompletionDate;
    },
    /**
    * en: Actual Completion Date
    */
    get actualCompletionDateFull() {
        return langMap[ep.resxCulture].actualCompletionDateFull || langMap.en.actualCompletionDateFull;
    },
    /**
    * en: Auto assign new issues to:
    */
    get AutoAssign_Issue() {
        return langMap[ep.resxCulture].AutoAssign_Issue || langMap.en.AutoAssign_Issue;
    },
    /**
    * en: The member chosen will be assigned every time an activity is added to the project
    */
    get AutoAssign_Note() {
        return langMap[ep.resxCulture].AutoAssign_Note || langMap.en.AutoAssign_Note;
    },
    /**
    * en: Auto assign new requests to:
    */
    get AutoAssign_Request() {
        return langMap[ep.resxCulture].AutoAssign_Request || langMap.en.AutoAssign_Request;
    },
    /**
    * en: Auto assign new tasks to:
    */
    get AutoAssign_Task() {
        return langMap[ep.resxCulture].AutoAssign_Task || langMap.en.AutoAssign_Task;
    },
    /**
    * en: Auto assign
    */
    get AutoAssign_Title() {
        return langMap[ep.resxCulture].AutoAssign_Title || langMap.en.AutoAssign_Title;
    },
    /**
    * en: The project baseline is captured. Go to a Gantt view and choose the 'Show' option to check it.
    */
    get BaselineCapturedFeedback() {
        return langMap[ep.resxCulture].BaselineCapturedFeedback || langMap.en.BaselineCapturedFeedback;
    },
    /**
    * en: Capture baseline
    */
    get BaselineCaptureLabel() {
        return langMap[ep.resxCulture].BaselineCaptureLabel || langMap.en.BaselineCaptureLabel;
    },
    /**
    * en: Overwrite the current baseline?
    */
    get BaselineOverwrite() {
        return langMap[ep.resxCulture].BaselineOverwrite || langMap.en.BaselineOverwrite;
    },
    /**
    * en: You already have a baseline for this project. If you proceed, the current baseline will be lost.
    */
    get BaselineOverwriteDescription() {
        return langMap[ep.resxCulture].BaselineOverwriteDescription || langMap.en.BaselineOverwriteDescription;
    },
    /**
    * en: The project baseline is overwritten. Go to a Gantt view and choose the 'Show' option to check it.
    */
    get BaselineOverwrittenFeedback() {
        return langMap[ep.resxCulture].BaselineOverwrittenFeedback || langMap.en.BaselineOverwrittenFeedback;
    },
    /**
    * en: Overwrite baseline
    */
    get BaselineRecaptureLabel() {
        return langMap[ep.resxCulture].BaselineRecaptureLabel || langMap.en.BaselineRecaptureLabel;
    },
    /**
    * en: The baseline has been successfully captured.
    */
    get BaselineSuccess() {
        return langMap[ep.resxCulture].BaselineSuccess || langMap.en.BaselineSuccess;
    },
    /**
    * en: Invoiced
    */
    get Billed() {
        return langMap[ep.resxCulture].Billed || langMap.en.Billed;
    },
    /**
    * en: Billing
    */
    get Billing() {
        return langMap[ep.resxCulture].Billing || langMap.en.Billing;
    },
    /**
    * en: Billing settings
    */
    get BillingSettingsTitle() {
        return langMap[ep.resxCulture].BillingSettingsTitle || langMap.en.BillingSettingsTitle;
    },
    /**
    * en: Not billable
    */
    get BillingTypeNotBillable() {
        return langMap[ep.resxCulture].BillingTypeNotBillable || langMap.en.BillingTypeNotBillable;
    },
    /**
    * en: Project billing settings
    */
    get BillingTypeProjectBillingSettings() {
        return langMap[ep.resxCulture].BillingTypeProjectBillingSettings || langMap.en.BillingTypeProjectBillingSettings;
    },
    /**
    * en: Notifications
    */
    get btnNotifications() {
        return langMap[ep.resxCulture].btnNotifications || langMap.en.btnNotifications;
    },
    /**
    * en:  left
    */
    get BudgetLeft() {
        return langMap[ep.resxCulture].BudgetLeft || langMap.en.BudgetLeft;
    },
    /**
    * en:  total
    */
    get BudgetTotal() {
        return langMap[ep.resxCulture].BudgetTotal || langMap.en.BudgetTotal;
    },
    /**
    * en: by 
    */
    get By() {
        return langMap[ep.resxCulture].By || langMap.en.By;
    },
    /**
    * en: change
    */
    get Change() {
        return langMap[ep.resxCulture].Change || langMap.en.Change;
    },
    /**
    * en: Close
    */
    get Close() {
        return langMap[ep.resxCulture].Close || langMap.en.Close;
    },
    /**
    * en: Complete "{0}"?
    */
    get ConfirmStatusDialogTitle() {
        return langMap[ep.resxCulture].ConfirmStatusDialogTitle || langMap.en.ConfirmStatusDialogTitle;
    },
    /**
    * en: Create invoice
    */
    get CreateInvoice_Title() {
        return langMap[ep.resxCulture].CreateInvoice_Title || langMap.en.CreateInvoice_Title;
    },
    /**
    * en: 1#{0} day#{0} days
    */
    get DayPluralFormat() {
        return langMap[ep.resxCulture].DayPluralFormat || langMap.en.DayPluralFormat;
    },
    /**
    * en: ({0}d)
    */
    get Days() {
        return langMap[ep.resxCulture].Days || langMap.en.Days;
    },
    /**
    * en: Delete activity
    */
    get DeleteActivity() {
        return langMap[ep.resxCulture].DeleteActivity || langMap.en.DeleteActivity;
    },
    /**
    * en: Delete project
    */
    get DeleteProject() {
        return langMap[ep.resxCulture].DeleteProject || langMap.en.DeleteProject;
    },
    /**
    * en: 1#{0} Dependency#{0} Dependencies
    */
    get Dependencies_Count() {
        return langMap[ep.resxCulture].Dependencies_Count || langMap.en.Dependencies_Count;
    },
    /**
    * en: indicates that current project member's permissions differ from the default role permissions
    */
    get DifferPermissionsMessage() {
        return langMap[ep.resxCulture].DifferPermissionsMessage || langMap.en.DifferPermissionsMessage;
    },
    /**
    * en: Disable dates rollup
    */
    get Disable_Dates_Rollup() {
        return langMap[ep.resxCulture].Disable_Dates_Rollup || langMap.en.Disable_Dates_Rollup;
    },
    /**
    * en: Dates rollup has been disabled
    */
    get Disable_Dates_Rollup_Feedback() {
        return langMap[ep.resxCulture].Disable_Dates_Rollup_Feedback || langMap.en.Disable_Dates_Rollup_Feedback;
    },
    /**
    * en: due in {0}
    */
    get DueIn_Ok() {
        return langMap[ep.resxCulture].DueIn_Ok || langMap.en.DueIn_Ok;
    },
    /**
    * en: {0} overdue
    */
    get DueIn_Trouble() {
        return langMap[ep.resxCulture].DueIn_Trouble || langMap.en.DueIn_Trouble;
    },
    /**
    * en: due today
    */
    get DueIn_Warning() {
        return langMap[ep.resxCulture].DueIn_Warning || langMap.en.DueIn_Warning;
    },
    /**
    * en: Edit role and permissions
    */
    get EditRoleAndPermissions() {
        return langMap[ep.resxCulture].EditRoleAndPermissions || langMap.en.EditRoleAndPermissions;
    },
    /**
    * en: Enable and Reschedule
    */
    get Enable_And_Reschedule() {
        return langMap[ep.resxCulture].Enable_And_Reschedule || langMap.en.Enable_And_Reschedule;
    },
    /**
    * en: Enable dates rollup
    */
    get Enable_Dates_Rollup() {
        return langMap[ep.resxCulture].Enable_Dates_Rollup || langMap.en.Enable_Dates_Rollup;
    },
    /**
    * en: Enabling dates rollup will reschedule this project.
    */
    get Enable_Dates_Rollup_Description() {
        return langMap[ep.resxCulture].Enable_Dates_Rollup_Description || langMap.en.Enable_Dates_Rollup_Description;
    },
    /**
    * en: Dates rollup has been enabled
    */
    get Enable_Dates_Rollup_Feedback() {
        return langMap[ep.resxCulture].Enable_Dates_Rollup_Feedback || langMap.en.Enable_Dates_Rollup_Feedback;
    },
    /**
    * en: Project dates will be updated
    */
    get Enable_Dates_Rollup_Title() {
        return langMap[ep.resxCulture].Enable_Dates_Rollup_Title || langMap.en.Enable_Dates_Rollup_Title;
    },
    /**
    * en: Planned End Date: 
    */
    get endDate() {
        return langMap[ep.resxCulture].endDate || langMap.en.endDate;
    },
    /**
    * en: Planned End Date
    */
    get endDateFull() {
        return langMap[ep.resxCulture].endDateFull || langMap.en.endDateFull;
    },
    /**
    * en: 'End date' cannot be less then 'Start date'
    */
    get endLessThenStartMsg() {
        return langMap[ep.resxCulture].endLessThenStartMsg || langMap.en.endLessThenStartMsg;
    },
    /**
    * en: 1# estimated hour# estimated hours
    */
    get estimatedHours() {
        return langMap[ep.resxCulture].estimatedHours || langMap.en.estimatedHours;
    },
    /**
    * en: Export to MS Project
    */
    get ExportToMsProject() {
        return langMap[ep.resxCulture].ExportToMsProject || langMap.en.ExportToMsProject;
    },
    /**
    * en: 1#{0} field#{0} fields
    */
    get Fields() {
        return langMap[ep.resxCulture].Fields || langMap.en.Fields;
    },
    /**
    * en: {0} must still be filled in
    */
    get FillCustomFields() {
        return langMap[ep.resxCulture].FillCustomFields || langMap.en.FillCustomFields;
    },
    /**
    * en: Follow
    */
    get Follow() {
        return langMap[ep.resxCulture].Follow || langMap.en.Follow;
    },
    /**
    * en: Follow all activities
    */
    get follow_all_activities_label() {
        return langMap[ep.resxCulture].follow_all_activities_label || langMap.en.follow_all_activities_label;
    },
    /**
    * en: Hide checklist
    */
    get hide_checklist_label() {
        return langMap[ep.resxCulture].hide_checklist_label || langMap.en.hide_checklist_label;
    },
    /**
    * en: Hide custom fields
    */
    get HideCustomFields() {
        return langMap[ep.resxCulture].HideCustomFields || langMap.en.HideCustomFields;
    },
    /**
    * en: 1# hour left# hours left
    */
    get hoursLeft() {
        return langMap[ep.resxCulture].hoursLeft || langMap.en.hoursLeft;
    },
    /**
    * en: h of 
    */
    get HoursOf() {
        return langMap[ep.resxCulture].HoursOf || langMap.en.HoursOf;
    },
    /**
    * en: ... read all
    */
    get HtmlField_ReadAll() {
        return langMap[ep.resxCulture].HtmlField_ReadAll || langMap.en.HtmlField_ReadAll;
    },
    /**
    * en: I'm done
    */
    get ImDoneText() {
        return langMap[ep.resxCulture].ImDoneText || langMap.en.ImDoneText;
    },
    /**
    * en: Select a customer to be able to create an invoice
    */
    get invoice_creation_no_customer_disabled_reason() {
        return langMap[ep.resxCulture].invoice_creation_no_customer_disabled_reason || langMap.en.invoice_creation_no_customer_disabled_reason;
    },
    /**
    * en: This is a milestone
    */
    get IsMilestone() {
        return langMap[ep.resxCulture].IsMilestone || langMap.en.IsMilestone;
    },
    /**
    * en: Issue
    */
    get issue() {
        return langMap[ep.resxCulture].issue || langMap.en.issue;
    },
    /**
    * en: Mark as a milestone
    */
    get MarkAsMilestone() {
        return langMap[ep.resxCulture].MarkAsMilestone || langMap.en.MarkAsMilestone;
    },
    /**
    * en: Add
    */
    get MemberPermission_Add() {
        return langMap[ep.resxCulture].MemberPermission_Add || langMap.en.MemberPermission_Add;
    },
    /**
    * en: Add for someone else
    */
    get MemberPermission_Add_For_Someone_Else() {
        return langMap[ep.resxCulture].MemberPermission_Add_For_Someone_Else || langMap.en.MemberPermission_Add_For_Someone_Else;
    },
    /**
    * en: Add own
    */
    get MemberPermission_Add_Own() {
        return langMap[ep.resxCulture].MemberPermission_Add_Own || langMap.en.MemberPermission_Add_Own;
    },
    /**
    * en: Edit all actual
    */
    get MemberPermission_CanEditActualExpenses() {
        return langMap[ep.resxCulture].MemberPermission_CanEditActualExpenses || langMap.en.MemberPermission_CanEditActualExpenses;
    },
    /**
    * en: Edit all planned
    */
    get MemberPermission_CanEditPlannedExpenses() {
        return langMap[ep.resxCulture].MemberPermission_CanEditPlannedExpenses || langMap.en.MemberPermission_CanEditPlannedExpenses;
    },
    /**
    * en: Add own
    */
    get MemberPermission_CanLogExpenses() {
        return langMap[ep.resxCulture].MemberPermission_CanLogExpenses || langMap.en.MemberPermission_CanLogExpenses;
    },
    /**
    * en: Manage members and permissions
    */
    get MemberPermission_CanManageProjectMembers() {
        return langMap[ep.resxCulture].MemberPermission_CanManageProjectMembers || langMap.en.MemberPermission_CanManageProjectMembers;
    },
    /**
    * en: Manage members, permissions and allocations
    */
    get MemberPermission_CanManageProjectMembersAndAllocations() {
        return langMap[ep.resxCulture].MemberPermission_CanManageProjectMembersAndAllocations || langMap.en.MemberPermission_CanManageProjectMembersAndAllocations;
    },
    /**
    * en: View all
    */
    get MemberPermission_CanViewAllExpenses() {
        return langMap[ep.resxCulture].MemberPermission_CanViewAllExpenses || langMap.en.MemberPermission_CanViewAllExpenses;
    },
    /**
    * en: View
    */
    get MemberPermission_CanViewMembersAndAssignees() {
        return langMap[ep.resxCulture].MemberPermission_CanViewMembersAndAssignees || langMap.en.MemberPermission_CanViewMembersAndAssignees;
    },
    /**
    * en: Delete
    */
    get MemberPermission_Delete() {
        return langMap[ep.resxCulture].MemberPermission_Delete || langMap.en.MemberPermission_Delete;
    },
    /**
    * en: Delete all
    */
    get MemberPermission_Delete_All() {
        return langMap[ep.resxCulture].MemberPermission_Delete_All || langMap.en.MemberPermission_Delete_All;
    },
    /**
    * en: Delete/Archive
    */
    get MemberPermission_Delete_Or_Archive() {
        return langMap[ep.resxCulture].MemberPermission_Delete_Or_Archive || langMap.en.MemberPermission_Delete_Or_Archive;
    },
    /**
    * en: Edit
    */
    get MemberPermission_Edit() {
        return langMap[ep.resxCulture].MemberPermission_Edit || langMap.en.MemberPermission_Edit;
    },
    /**
    * en: Edit all
    */
    get MemberPermission_Edit_All() {
        return langMap[ep.resxCulture].MemberPermission_Edit_All || langMap.en.MemberPermission_Edit_All;
    },
    /**
    * en: Edit assigned
    */
    get MemberPermission_Edit_Assigned() {
        return langMap[ep.resxCulture].MemberPermission_Edit_Assigned || langMap.en.MemberPermission_Edit_Assigned;
    },
    /**
    * en: Manage assignees
    */
    get MemberPermission_Manage_Assigned() {
        return langMap[ep.resxCulture].MemberPermission_Manage_Assigned || langMap.en.MemberPermission_Manage_Assigned;
    },
    /**
    * en: View all
    */
    get MemberPermission_View_All() {
        return langMap[ep.resxCulture].MemberPermission_View_All || langMap.en.MemberPermission_View_All;
    },
    /**
    * en: View and manage
    */
    get MemberPermission_View_and_Manage() {
        return langMap[ep.resxCulture].MemberPermission_View_and_Manage || langMap.en.MemberPermission_View_and_Manage;
    },
    /**
    * en: View assigned
    */
    get MemberPermission_View_Assigned() {
        return langMap[ep.resxCulture].MemberPermission_View_Assigned || langMap.en.MemberPermission_View_Assigned;
    },
    /**
    * en: Expenses:
    */
    get MemberPermissions_ExpensesTitle() {
        return langMap[ep.resxCulture].MemberPermissions_ExpensesTitle || langMap.en.MemberPermissions_ExpensesTitle;
    },
    /**
    * en: Members & assignees:
    */
    get MemberPermissions_MembersAndAssigneesTitle() {
        return langMap[ep.resxCulture].MemberPermissions_MembersAndAssigneesTitle || langMap.en.MemberPermissions_MembersAndAssigneesTitle;
    },
    /**
    * en: Activities:
    */
    get MemberPermissions_TasksTitle() {
        return langMap[ep.resxCulture].MemberPermissions_TasksTitle || langMap.en.MemberPermissions_TasksTitle;
    },
    /**
    * en: Project:
    */
    get MemberPermissions_ThisProjectTitle() {
        return langMap[ep.resxCulture].MemberPermissions_ThisProjectTitle || langMap.en.MemberPermissions_ThisProjectTitle;
    },
    /**
    * en: Time entries:
    */
    get MemberPermissions_TimeEntriesTitle() {
        return langMap[ep.resxCulture].MemberPermissions_TimeEntriesTitle || langMap.en.MemberPermissions_TimeEntriesTitle;
    },
    /**
    * en: 1#{0} Member#{0} Members
    */
    get Members() {
        return langMap[ep.resxCulture].Members || langMap.en.Members;
    },
    /**
    * en: No assignee
    */
    get no_assignee() {
        return langMap[ep.resxCulture].no_assignee || langMap.en.no_assignee;
    },
    /**
    * en:  on 
    */
    get On() {
        return langMap[ep.resxCulture].On || langMap.en.On;
    },
    /**
    * en: Budget for this activity:
    */
    get OwnBudget() {
        return langMap[ep.resxCulture].OwnBudget || langMap.en.OwnBudget;
    },
    /**
    * en: 1#% done#% done
    */
    get PercentDone() {
        return langMap[ep.resxCulture].PercentDone || langMap.en.PercentDone;
    },
    /**
    * en: {0}'s permissions
    */
    get PermissionsSettingsTitle() {
        return langMap[ep.resxCulture].PermissionsSettingsTitle || langMap.en.PermissionsSettingsTitle;
    },
    /**
    * en: Project
    */
    get project() {
        return langMap[ep.resxCulture].project || langMap.en.project;
    },
    /**
    * en: The requested project could not be found, or you do not have the permission to access it. Consult with your {brandName} administrator for possible causes. Object key is {0}.
    */
    get Project_NotFound_Message() {
        return langMap[ep.resxCulture].Project_NotFound_Message || langMap.en.Project_NotFound_Message;
    },
    /**
    * en: Requested Project Not Found
    */
    get Project_NotFound_Title() {
        return langMap[ep.resxCulture].Project_NotFound_Title || langMap.en.Project_NotFound_Title;
    },
    /**
    * en: Project was completed <b>{0} before</b> its planned end date
    */
    get Project_WasCompleted_Ok() {
        return langMap[ep.resxCulture].Project_WasCompleted_Ok || langMap.en.Project_WasCompleted_Ok;
    },
    /**
    * en: Project was completed  <b>{0} after</b> its planned end date
    */
    get Project_WasCompleted_Trouble() {
        return langMap[ep.resxCulture].Project_WasCompleted_Trouble || langMap.en.Project_WasCompleted_Trouble;
    },
    /**
    * en: Project was completed on its planned end date
    */
    get Project_WasCompleted_Warning() {
        return langMap[ep.resxCulture].Project_WasCompleted_Warning || langMap.en.Project_WasCompleted_Warning;
    },
    /**
    * en: 1#{0} of {1} spent#{0} of {1} spent
    */
    get RatioOfMoneySpent() {
        return langMap[ep.resxCulture].RatioOfMoneySpent || langMap.en.RatioOfMoneySpent;
    },
    /**
    * en: Repeat
    */
    get RepeatActivity() {
        return langMap[ep.resxCulture].RepeatActivity || langMap.en.RepeatActivity;
    },
    /**
    * en: Request
    */
    get request() {
        return langMap[ep.resxCulture].request || langMap.en.request;
    },
    /**
    * en: You have completed your assignment. 
    */
    get ResumeWorkHelpText() {
        return langMap[ep.resxCulture].ResumeWorkHelpText || langMap.en.ResumeWorkHelpText;
    },
    /**
    * en: Resume work
    */
    get ResumeWorkText() {
        return langMap[ep.resxCulture].ResumeWorkText || langMap.en.ResumeWorkText;
    },
    /**
    * en: Role for this project
    */
    get RoleTitle() {
        return langMap[ep.resxCulture].RoleTitle || langMap.en.RoleTitle;
    },
    /**
    * en: Save
    */
    get Save() {
        return langMap[ep.resxCulture].Save || langMap.en.Save;
    },
    /**
    * en: Set Actual Completion Date
    */
    get Set_actualCompletionDate() {
        return langMap[ep.resxCulture].Set_actualCompletionDate || langMap.en.Set_actualCompletionDate;
    },
    /**
    * en: Set Budget
    */
    get Set_budget() {
        return langMap[ep.resxCulture].Set_budget || langMap.en.Set_budget;
    },
    /**
    * en: Set Category
    */
    get Set_categoryId() {
        return langMap[ep.resxCulture].Set_categoryId || langMap.en.Set_categoryId;
    },
    /**
    * en: Set Customer
    */
    get Set_customerId() {
        return langMap[ep.resxCulture].Set_customerId || langMap.en.Set_customerId;
    },
    /**
    * en: Set Dates or Duration
    */
    get Set_dates() {
        return langMap[ep.resxCulture].Set_dates || langMap.en.Set_dates;
    },
    /**
    * en: Add description
    */
    get Set_description() {
        return langMap[ep.resxCulture].Set_description || langMap.en.Set_description;
    },
    /**
    * en: Set Planned End Date
    */
    get Set_endDate() {
        return langMap[ep.resxCulture].Set_endDate || langMap.en.Set_endDate;
    },
    /**
    * en: Set Estimated Hours
    */
    get Set_estimatedHours() {
        return langMap[ep.resxCulture].Set_estimatedHours || langMap.en.Set_estimatedHours;
    },
    /**
    * en: Set Hours Left
    */
    get Set_hoursLeft() {
        return langMap[ep.resxCulture].Set_hoursLeft || langMap.en.Set_hoursLeft;
    },
    /**
    * en: Set Labor Budget
    */
    get Set_labor_budget() {
        return langMap[ep.resxCulture].Set_labor_budget || langMap.en.Set_labor_budget;
    },
    /**
    * en: Set Portfolio
    */
    get Set_portfolioId() {
        return langMap[ep.resxCulture].Set_portfolioId || langMap.en.Set_portfolioId;
    },
    /**
    * en: Set Hours Left
    */
    get Set_short_hoursLeft() {
        return langMap[ep.resxCulture].Set_short_hoursLeft || langMap.en.Set_short_hoursLeft;
    },
    /**
    * en: Set as top-level activity
    */
    get SetAsRootLevel() {
        return langMap[ep.resxCulture].SetAsRootLevel || langMap.en.SetAsRootLevel;
    },
    /**
    * en: Set as Completed
    */
    get SetCompleted() {
        return langMap[ep.resxCulture].SetCompleted || langMap.en.SetCompleted;
    },
    /**
    * en: 1# hour left# hours left
    */
    get short_hoursLeft() {
        return langMap[ep.resxCulture].short_hoursLeft || langMap.en.short_hoursLeft;
    },
    /**
    * en: Show checklist
    */
    get show_checklist_label() {
        return langMap[ep.resxCulture].show_checklist_label || langMap.en.show_checklist_label;
    },
    /**
    * en: Show custom fields
    */
    get ShowCustomFields() {
        return langMap[ep.resxCulture].ShowCustomFields || langMap.en.ShowCustomFields;
    },
    /**
    * en: 1#h spent#h spent
    */
    get Spent() {
        return langMap[ep.resxCulture].Spent || langMap.en.Spent;
    },
    /**
    * en: Status: 
    */
    get Status() {
        return langMap[ep.resxCulture].Status || langMap.en.Status;
    },
    /**
    * en: Task
    */
    get task() {
        return langMap[ep.resxCulture].task || langMap.en.task;
    },
    /**
    * en: The requested activity could not be found, or you do not have the permission to access it. Consult with your {brandName} administrator for possible causes. Object key is {0}.
    */
    get Task_NotFound_Message() {
        return langMap[ep.resxCulture].Task_NotFound_Message || langMap.en.Task_NotFound_Message;
    },
    /**
    * en: Requested Activity Not Found
    */
    get Task_NotFound_Title() {
        return langMap[ep.resxCulture].Task_NotFound_Title || langMap.en.Task_NotFound_Title;
    },
    /**
    * en: Activity was completed <b>{0} before</b> its planned end date
    */
    get Task_WasCompleted_Ok() {
        return langMap[ep.resxCulture].Task_WasCompleted_Ok || langMap.en.Task_WasCompleted_Ok;
    },
    /**
    * en: Activity was completed  <b>{0} after</b> its planned end date
    */
    get Task_WasCompleted_Trouble() {
        return langMap[ep.resxCulture].Task_WasCompleted_Trouble || langMap.en.Task_WasCompleted_Trouble;
    },
    /**
    * en: Activity was completed on its planned end date
    */
    get Task_WasCompleted_Warning() {
        return langMap[ep.resxCulture].Task_WasCompleted_Warning || langMap.en.Task_WasCompleted_Warning;
    },
    /**
    * en: Today
    */
    get today() {
        return langMap[ep.resxCulture].today || langMap.en.today;
    },
    /**
    * en: Unfollow
    */
    get UnFollow() {
        return langMap[ep.resxCulture].UnFollow || langMap.en.UnFollow;
    },
    /**
    * en: Unfollow all activities
    */
    get unfollow_all_activities_label() {
        return langMap[ep.resxCulture].unfollow_all_activities_label || langMap.en.unfollow_all_activities_label;
    },
    /**
    * en:  There are unsaved changes. Are you sure you would like to leave this page?
    */
    get WindowUnload_UnsavedChanges() {
        return langMap[ep.resxCulture].WindowUnload_UnsavedChanges || langMap.en.WindowUnload_UnsavedChanges;
    },
};

// @ts-ignore
ep.resources = ep.resources || {};

// @ts-ignore
ep.resources.taskDetails = taskDetailsResx;
